// @flow

import type { Action } from './store.type';

export const UPDATE_EXECUTION_ID = 'UPDATE_EXECUTION_ID';

type UPDATE_EXECUTION_ID_TYPE = 'UPDATE_EXECUTION_ID';

type UpdateQueryExecutionIdAction = Action<UPDATE_EXECUTION_ID_TYPE, null>;

export type QueryExecutionIdAction = UpdateQueryExecutionIdAction;

export type QueryExecutionIdState = {
  list: Array<Object>
};
